import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import HeroSectionImage from '../../images/HomePage/HeroSection/HH25_HeroSectionImage.png';
import Logo from '../../images/Logo/HH25_Logo.png';

const MaintenancePage = () => {
    useEffect(() => {
        // Ocultar navbar y footer
        document.querySelector('.navbar')?.style.setProperty('display', 'none');
        document.querySelector('footer')?.style.setProperty('display', 'none');

        // Limpiar al desmontar
        return () => {
            document.querySelector('.navbar')?.style.removeProperty('display');
            document.querySelector('footer')?.style.removeProperty('display');
        };
    }, []);

    return (
        <div className="maintenance-page-container" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Helmet>
                <title>HappyHome - Sitio en Mantenimiento</title>
                <meta name="description" content="HappyHome se encuentra temporalmente en mantenimiento. Estamos trabajando para mejorar tu experiencia. ¡Volveremos pronto!" />
                <meta name="keywords" content="mantenimiento, sitio web, happyhome, mejora" />
                <meta property="og:title" content="HappyHome - Sitio en Mantenimiento" />
                <meta property="og:description" content="HappyHome se encuentra temporalmente en mantenimiento. ¡Volveremos pronto!" />
                <meta property="og:image" content={HeroSectionImage} />
                <meta property="og:url" content="http://www.happyhome.com.ar" />
            </Helmet>
            <div className="section-title" style={{ textAlign: 'center', padding: '2rem' }}>
                <img 
                    src={Logo} 
                    alt="HappyHome Logo" 
                    className="maintenance-logo"
                />
                <h2>¡Nos estamos renovando!</h2>
            </div>
        </div>
    );
};

export default MaintenancePage; 